export default [
	{
		path: "/formPreview/preachForm",
		name: "preachForm",
		component: resolve => require.ensure([], () => resolve(require("@/views/formPreview/preach-form")), "preachForm"),
		meta: {
			title: "表单预览"
		}
	},
	{
		path: "/formPreview/followOrSatisfiedForm",
		name: "followOrSatisfiedForm",
		component: resolve => require.ensure([], () => resolve(require("@/views/formPreview/follow-satisfied-form")), "followOrSatisfiedForm"),
		meta: {
			title: "表单预览"
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/formPreview.js